//axios相关配置项
import axios from "axios";
import context from '../main.js'

let isLoginRedirecting = false

const requests = axios.create({
    baseURL: process.env.VUE_APP_HOST,
    method: "POST",
    timeout: 30000,
    maxRedirects: 3,
    headers: {
        'X-Custom-Header': 'foobar',
    },
})
// 错误处理函数
const err = (error) => {
    console.log(error)
    if (error && error.response && error.response.data) {
        return Promise.reject(error.response.data.message || error.message)
    }
    return Promise.reject(error.message || 'Network Error')
}

const redirectToLoginWithMessage = (message) => {
    if (isLoginRedirecting) {
        return
    }
    isLoginRedirecting = true
    localStorage.removeItem(process.env.VUE_APP_USER_KEY)
    context.$alert(message, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        callback: () => {
            context.$router.push('/login')
            isLoginRedirecting = false
        }
    })
}

const getTokenDebugInfo = () => {
    try {
        const storageData = localStorage.getItem(process.env.VUE_APP_USER_KEY)
        if (!storageData) {
            return { hasStorage: false, hasToken: false, tokenSuffix: 'none' }
        }
        const parsed = JSON.parse(storageData)
        const userInfo = parsed && parsed.userInfo ? parsed.userInfo : parsed
        const token = userInfo && userInfo.token
        return {
            hasStorage: true,
            hasToken: Boolean(token),
            tokenSuffix: token ? token.slice(-8) : 'none'
        }
    } catch (e) {
        return { hasStorage: false, hasToken: false, tokenSuffix: 'parse_error' }
    }
}

requests.interceptors.request.use(function (config) {
    //添加token参数
    // 获取用户信息，处理过期检查
    let userInfo = null;
    try {
      const storageData = localStorage.getItem(process.env.VUE_APP_USER_KEY);
      if (storageData) {
        const parsed = JSON.parse(storageData);
        // 检查是否有过期时间设置
        if (parsed.expireTime) {
          // 检查是否过期
          if (new Date().getTime() > parsed.expireTime) {
            redirectToLoginWithMessage('登录已过期，请重新登录');
            return Promise.reject('登录已过期，请重新登录');
          } else {
            userInfo = parsed.userInfo;
          }
        } else {
          // 兼容旧数据格式
          userInfo = parsed;
        }
      }
    } catch (error) {
      console.error('解析用户信息失败:', error);
      localStorage.removeItem(process.env.VUE_APP_USER_KEY);
      userInfo = null;
    }

    if (userInfo != null) {
        try {
            //请求头里面加token
            config.headers.token = userInfo.token;
        } catch (e) {
            console.log("err =" + e.message)
        }
    }
    return config
})


// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
    const res = response.data
    if (res.status === 90002) {
        const message = res.message || '登录已失效，请重新登录'
        console.error('[auth] token 校验失败', {
            message,
            url: response && response.config ? response.config.url : '',
            tokenDebug: getTokenDebugInfo()
        })
        redirectToLoginWithMessage(message)
        return Promise.reject(message)
    }
    return res
}, err)

export default requests
